function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.52 2.9c-.6-.6-1.47-.9-2.59-.9H7.35C5.1 2 3.86 3.24 3.86 5.49c0 1.12.3 1.99.9 2.59.6.6 1.47.9 2.59.9h5.58c2.25 0 3.49-1.24 3.49-3.49 0-1.12-.3-1.99-.9-2.59z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M10.6 15.02h-.93c-.95 0-2.09.36-2.09 2.09v2.79c0 1.73 1.14 2.09 2.09 2.09h.93c.95 0 2.09-.36 2.09-2.09v-2.79c.01-1.72-1.13-2.09-2.09-2.09z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.65 4.79h-.28c.03.22.05.45.05.7 0 .25-.02.48-.05.7h.28c2.09 0 2.09.28 2.09 2.09v1.86c0 1.81 0 2.09-2.09 2.09h-3.72c-2.99 0-3.42 1.42-3.48 2.8.07 0 .15-.01.22-.01h.93c.08 0 .16.01.25.01.05-1.01.34-1.41 2.08-1.41h3.72c3.25 0 3.49-1.32 3.49-3.49V8.28c0-2.17-.24-3.49-3.49-3.49z"
})));